export const appRootId = "nuxt-root"

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","href":"/favicon/android_192.png","type":"image/png","sizes":"192x192"},{"rel":"icon","href":"/favicon/favicon.svg","type":"image/svg+xml"},{"rel":"shortcut icon","href":"/favicon/favicon.ico"},{"rel":"apple-touch-icon","href":"/favicon/apple_180.png"},{"rel":"manifest","href":"/favicon/manifest.webmanifest"},{"rel":"stylesheet","type":"text/css","media":"screen","href":"/css/prerendered.style.css"},{"rel":"stylesheet","type":"text/css","media":"screen","href":"/css/swiper-bundle.min.css"}],"style":[],"script":[{"src":"/js/vendor/jquery-3.6.3.js"},{"src":"/js/etx/etx-inviewport-1.2.js","defer":true},{"src":"/js/etx/etx-lazyload-1.0.js","defer":true},{"src":"/js/etx/etx-accordion-1.1.js","defer":true},{"src":"/js/etx/etx-lightbox-1.0.js","defer":true},{"src":"/js/etx/etx-sticky-1.1.js","defer":true},{"src":"/js/custom/ui.js","defer":true},{"src":"/js/vendor/swiper-bundle.min.js","defer":true}],"noscript":[],"title":"Equans Switzerland","htmlAttrs":{"tagDuplicateStrategy":"merge","lang":"de"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootTag = "div"

export const appRootAttrs = {"id":"nuxt-root"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#nuxt-root'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false